const EVENT_TYPES = Object.freeze({
    USER_PROPERTIES: 'userProperties',
    QUIZ_PAGE_VISITED: 'quiz_page_visited',
    QUIZ_STARTED: 'quiz_started',
    QUIZ_QUESTION_VISITED: 'quiz_question_visited',
    QUIZ_BACK_CLICKED: 'quiz_back_clicked',
    QUIZ_COMPLETED: 'quiz_completed',
    PROFILE_PAGE_VISITED: 'profile_page_visited',
    PLAN_LOADER_PAGE_VISITED: 'plan_loader_page_visited',
    PLAN_LOADER_PAGE_QUESTION_VISITED: 'plan_loader_page_question_visited',
    EMAIL_PAGE_VISITED: 'email_page_visited',
    EMAIL_SUBMITTED: 'email_submitted',
    SALE_PAGE_VISITED: 'sale_page_visited',
    FIRST_PLAN_VIEWED: 'first_plan_viewed',
    PLAN_SELECTED: 'plan_selected',
    SALE_PRE_CHECKOUT_PAGE_VISITED: 'sale_pre_checkout_page_visited',
    SALE_CHECKOUT_INITIATE: 'sale_initiate_checkout',
    SALE_CHECKOUT_PAGE_VISITED: 'sale_checkout_page_visited',
    SALE_CHECKOUT_CLICK_PAY: 'sale_checkout_click_pay',
    UPSELL_BUNDLE_PAGE_VISITED: 'upsell_bundle_page_visited',
    UPSELL_BUNDLE_PRODUCT_CLICKED: 'upsell_bundle_product_clicked',
    UPSELL_PAGE_CLICK_PAY: 'upsell_page_click_pay',
    UPSELL_PAGE_SKIPPED: 'upsell_page_skipped',
    ONLINE_ACTIVITY_RISK_PAGE_VISITED: 'online_activity_risk_page_visited',
    DATA_LEAK_RISK_PAGE_VISITED: 'data_leak_risk_page_visited',
    FINANCIAL_FRAUD_RISK_PAGE_VISITED: 'financial_fraud_risk_page_visited',
    TRUST_PAGE_VISITED: 'trust_page_visited',
    QUIZ_INTRO1_PAGE_VISITED: 'quiz_intro1_page_visited',
    QUIZ_START_CLICKED: 'quiz_start_clicked',
    QUIZ_START_BUTTON_VIEWED: 'quiz_start_button_viewed',
    PRIVACY_RISK_PAGE_VISITED: 'privacy_risk_page_visited',
    SPYING_RISK_PAGE_VISITED: 'spying_risk_page_visited',
    UPSELL_LIVE_SUPPORT_PAGE_VISITED: 'upsell_live_support_page_visited',
    PASSWORD_LEAK_RISK_PAGE_VISITED: 'password_leak_risk_page_visited',
    CANCEL_ANYTIME_BLOCK_VIEWED: 'cancel_anytime_block_viewed'
});
const AMPLITUDE_EVENT_TYPES = Object.freeze({
    [EVENT_TYPES.QUIZ_PAGE_VISITED]: 'quiz_page_visited',
    [EVENT_TYPES.QUIZ_STARTED]: 'quiz_started',
    [EVENT_TYPES.QUIZ_QUESTION_VISITED]: ({ questionNumber }) => `quiz_question${questionNumber}_visited`,
    [EVENT_TYPES.QUIZ_BACK_CLICKED]: 'quiz_back_clicked',
    [EVENT_TYPES.QUIZ_COMPLETED]: 'quiz_completed',
    [EVENT_TYPES.PROFILE_PAGE_VISITED]: 'profile_page_visited',
    [EVENT_TYPES.PLAN_LOADER_PAGE_VISITED]: 'plan_loader_page_visited',
    [EVENT_TYPES.PLAN_LOADER_PAGE_QUESTION_VISITED]: ({ questionNumber }) => `plan_loader_page_question${questionNumber}`,
    [EVENT_TYPES.EMAIL_PAGE_VISITED]: 'email_page_visited',
    [EVENT_TYPES.EMAIL_SUBMITTED]: 'email_submitted',
    [EVENT_TYPES.SALE_PAGE_VISITED]: 'sale_page_visited',
    [EVENT_TYPES.FIRST_PLAN_VIEWED]: 'first_plan_viewed',
    [EVENT_TYPES.PLAN_SELECTED]: 'plan_selected',
    [EVENT_TYPES.SALE_PRE_CHECKOUT_PAGE_VISITED]: 'sale_pre_checkout_page_visited',
    [EVENT_TYPES.SALE_CHECKOUT_PAGE_VISITED]: 'sale_checkout_viewed',
    [EVENT_TYPES.SALE_CHECKOUT_CLICK_PAY]: 'sale_checkout_click_pay',
    [EVENT_TYPES.SALE_CHECKOUT_INITIATE]: 'checkout_initiated',
    [EVENT_TYPES.UPSELL_PAGE_CLICK_PAY]: 'upsell_page_click_pay',
    [EVENT_TYPES.UPSELL_PAGE_SKIPPED]: 'upsell_page_skipped',
    [EVENT_TYPES.UPSELL_BUNDLE_PAGE_VISITED]: 'upsell_bundle_page_visited',
    [EVENT_TYPES.UPSELL_BUNDLE_PRODUCT_CLICKED]: 'upsell_bundle_product_clicked',
    [EVENT_TYPES.TRUST_PAGE_VISITED]: 'trust_page_visited',
    [EVENT_TYPES.QUIZ_INTRO1_PAGE_VISITED]: 'quiz_intro1_page_visited',
    [EVENT_TYPES.ONLINE_ACTIVITY_RISK_PAGE_VISITED]: 'online_activity_risk_page_visited',
    [EVENT_TYPES.DATA_LEAK_RISK_PAGE_VISITED]: 'data_leak_risk_page_visited',
    [EVENT_TYPES.FINANCIAL_FRAUD_RISK_PAGE_VISITED]: 'financial_fraud_risk_page_visited',
    [EVENT_TYPES.QUIZ_START_CLICKED]: 'quiz_start_clicked',
    [EVENT_TYPES.QUIZ_START_BUTTON_VIEWED]: 'quiz_start_button_viewed',
    [EVENT_TYPES.PRIVACY_RISK_PAGE_VISITED]: 'privacy_risk_page_visited',
    [EVENT_TYPES.SPYING_RISK_PAGE_VISITED]: 'spying_risk_page_visited',
    [EVENT_TYPES.UPSELL_LIVE_SUPPORT_PAGE_VISITED]: 'upsell_live_support_page_visited',
    [EVENT_TYPES.PASSWORD_LEAK_RISK_PAGE_VISITED]: 'password_leak_risk_page_visited',
    [EVENT_TYPES.CANCEL_ANYTIME_BLOCK_VIEWED]: 'cancel_anytime_block_viewed'
});

const FACEBOOK_EVENT_TYPES = Object.freeze({
    [EVENT_TYPES.EMAIL_SUBMITTED]: 'Email submitted',
    [EVENT_TYPES.SALE_CHECKOUT_INITIATE]: 'InitiateCheckout'
});

const GROWTHBOOK_EVENT_TYPES = Object.freeze({
    [EVENT_TYPES.UPSELL_PAGE_CLICK_PAY]: 'upsell_page_click_pay',
    [EVENT_TYPES.UPSELL_BUNDLE_PAGE_VISITED]: 'upsell_bundle_page_visited',
    [EVENT_TYPES.QUIZ_START_CLICKED]: 'quiz_start_clicked'
});

export {
    EVENT_TYPES,
    AMPLITUDE_EVENT_TYPES,
    FACEBOOK_EVENT_TYPES,
    GROWTHBOOK_EVENT_TYPES
};
